import * as React from "react";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import axios from "axios";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Joi from "joi";
const initialRequestId={
  name: "",
  country_id: "",
}
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  bottom: "20%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxHeight: "700px",
  overflowY: "scroll",
  overflowX: "hidden",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
export default function UpdatePopUp({
  setUpdatePopUp,
  updatePopUp,
  government,
  id,
  setGovernment,
  getGovernments,
}) {

  const [errorList, setErrorList] = useState(null);
  const [apiErrors, setApiErrors] = useState(null);
  const [isLoading, setloading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [requestData, setRequestData] = useState({
    ...initialRequestId
  });

  useEffect(() => {
    setApiErrors([]);
    setErrorList([]);
  }, [requestData]);
  const handleClose = () => {
    setUpdatePopUp(false);
    setGovernment([]);
    setApiErrors([]);
    setErrorList([]);
    setRequestData({...initialRequestId});
    setloading(false);
  };

  let authToken = localStorage.getItem("userToken");

  //handle changes in all inputs except image (file)
  const handleChange = (event) => {
    setRequestData({
      ...requestData,
      [event.target.name]: event.target.value,
    });
  };
  //post new country to API
  const handleFormSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append("name", requestData.name);
    formData.append("country_id", requestData.country_id);
    let valRes = validateNewGovernment(requestData);
    if (valRes.error) {
      setErrorList(valRes.error.details);
    } else {
      try {
        setloading(true);
        let { data } = await axios.post(
          `https://atfalunaapp.com/api/dashboard/government/${id}/update`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
              "Content-Type": "multipart/form-data",
            },
            responseType: "json",
          }
        );

        if (data.message === "Successful") {
          setUpdatePopUp(false);
          setloading(false);
          getGovernments();
          setRequestData("");
          // setFile("");
        }
      } catch (error) {
        getGovernments();
        setApiErrors(error.response.data.errors);
        setloading(false);
        console.log("error");
      }
    }
  };
  const validateNewGovernment = (government) => {
    let schema = Joi.object({
      name: Joi.string().required().messages({
        "string.empty": `"name" can't be an empty field`,
        "any.required": `"name" is a required field`,
      }),
      country_id: Joi.number().required().messages({
        "number.empty": `"id" can't be an empty field`,
        "any.required": `"id" is a required field`,
      }),
    });
    return schema.validate(government, { abortEarly: false });
  };
  //get countries Id
  const getCountries = async () => {
    let { data } = await axios.get(
      "https://atfalunaapp.com/api/dashboard/country",
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "multipart/form-data",
        },
        responseType: "json",
      }
    );
    setCountries(data.data);
  };
  let countriesId = countries.map((country) => ({
    id: country.id,
    name: country.name,
  }));
  useEffect(() => {
    getCountries();
  }, []);
  useEffect(() => {
    if(government){
      let { name ,country} = government;
    setRequestData({ name ,country_id:country?.id||0});
    }
  }, [government]);
  return (
    <div>
      <Modal
        open={updatePopUp}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="position-relative">
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            className="text-center fw-bold mb-4"
          >
            Update Row
          </Typography>
          {errorList &&
            errorList.map((error, index) => {
              return (
                <div key={index} className="alert alert-danger">
                  {error.message}
                </div>
              );
            })}
          {apiErrors &&
            Object.keys(apiErrors).map((key) => (
              <div key={key} className="alert alert-danger">
                {key} must be {apiErrors[key][0].split(".")[1]}
              </div>
            ))}

          <div className="mb-2">
            <label htmlFor="name" className="form-label">
              Name
              <span className="required"> * </span>
              <span className="hide">This is a Required Feild</span>
            </label>
            <input
              className="form-control"
              type="text"
              id="name"
              name="name"
              placeholder={government.name}
              value={requestData.name}
              onChange={handleChange}
            />
          </div>

          <div className="mb-2">
            <label htmlFor="arVideo" className="form-label">
              Country
              <span className="required"> * </span>
              <span className="hide">This is a Required Feild</span>
            </label>

            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={requestData.country_id}
                onChange={handleChange}
                name="country_id"
                MenuProps={MenuProps}
                InputLabelProps={{ shrink: false }}
                input={<OutlinedInput label=" " />}
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                className="customSelect"
              >
                {countriesId.map((country) => (
                  <MenuItem key={country.id} value={country.id}>
                    {country.id} {`[ ${country.name} ]`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="closeButtn">
            <CloseIcon className="closeIcon" onClick={handleClose} />
          </div>
          <div className="d-flex justify-content-center align-items-center mt-4">
            <button
              type="button"
              onClick={handleFormSubmit}
              className="btn btn-light addBtn"
            >
              {isLoading == true ? (
                <div className="d-flex align-items-center">
                  <span>Loading... </span>
                  <CircularProgress className="loadingIcon" />
                </div>
              ) : (
                "Update"
              )}
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
